<template>
  <el-drawer
      title="方案列表"
      :visible.sync="visible"
      @open="init"
      @close="closeDrawer"
      direction="rtl"
      :with-header="false"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      size="1000px">
    <el-card class="box-card" shadow="never" style="border-bottom: none;height: 100vh;overflow-y: scroll">
      <div class="drawer-header">
        <h2 class="title">{{routerInfo.name}}-方案列表</h2>
      </div>
      <el-divider class="margin-bottom-15 margin-top-10"></el-divider>
      <el-table class="list-table" :data="programList" border :stripe="true" style="width: 100%" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="公司名称"></el-table-column>
        <el-table-column prop="schemeName" label="方案名称"></el-table-column>
        <el-table-column prop="amount" label="购买总数" width="100"></el-table-column>
        <el-table-column prop="allowance" label="余量" width="100"></el-table-column>
      </el-table>
    </el-card>
  </el-drawer>
</template>

<script>
  import {get, findSchemeByUserId} from '@/api/manage/company'
  import {mapGetters} from "vuex";

  export default {
    name: 'company-scheme-list',
    props: {
      routerInfo: null,
      visible:false
    },
    computed: {
      ...mapGetters(['user', 'company']),
    },
    data() {
      return {
        programList:[]
      };
    },
    methods: {
      init(){
        this.getProgramList();
      },
      closeDrawer(){
        this.$emit('done')
      },
      getProgramList() {
        findSchemeByUserId(this.routerInfo.userId).then(res => {
          get(this.company.id).then(resp => {
            let list = res.data.result
            list.map(item => {
              item.companyName = resp.data.result.name
            })
            this.programList = list
          })
        })
      },
    }
  }
</script>
